/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { Configuration } from '../configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { apiAdminBenchmarkRunItemsItemIdStopPost } from '../fn/admin/api-admin-benchmark-run-items-item-id-stop-post';
import { ApiAdminBenchmarkRunItemsItemIdStopPost$Params } from '../fn/admin/api-admin-benchmark-run-items-item-id-stop-post';
import { apiAdminBenchmarkRunsRunIdGet } from '../fn/admin/api-admin-benchmark-runs-run-id-get';
import { ApiAdminBenchmarkRunsRunIdGet$Params } from '../fn/admin/api-admin-benchmark-runs-run-id-get';
import { apiAdminBenchmarkRunsRunIdStopPost } from '../fn/admin/api-admin-benchmark-runs-run-id-stop-post';
import { ApiAdminBenchmarkRunsRunIdStopPost$Params } from '../fn/admin/api-admin-benchmark-runs-run-id-stop-post';
import { apiAdminBenchmarksBenchmarkIdDelete } from '../fn/admin/api-admin-benchmarks-benchmark-id-delete';
import { ApiAdminBenchmarksBenchmarkIdDelete$Params } from '../fn/admin/api-admin-benchmarks-benchmark-id-delete';
import { apiAdminBenchmarksBenchmarkIdGet } from '../fn/admin/api-admin-benchmarks-benchmark-id-get';
import { ApiAdminBenchmarksBenchmarkIdGet$Params } from '../fn/admin/api-admin-benchmarks-benchmark-id-get';
import { apiAdminBenchmarksBenchmarkIdPut } from '../fn/admin/api-admin-benchmarks-benchmark-id-put';
import { ApiAdminBenchmarksBenchmarkIdPut$Params } from '../fn/admin/api-admin-benchmarks-benchmark-id-put';
import { apiAdminBenchmarksBenchmarkIdRunsGet } from '../fn/admin/api-admin-benchmarks-benchmark-id-runs-get';
import { ApiAdminBenchmarksBenchmarkIdRunsGet$Params } from '../fn/admin/api-admin-benchmarks-benchmark-id-runs-get';
import { apiAdminBenchmarksBenchmarkIdRunsModelVersionIdPost } from '../fn/admin/api-admin-benchmarks-benchmark-id-runs-model-version-id-post';
import { ApiAdminBenchmarksBenchmarkIdRunsModelVersionIdPost$Params } from '../fn/admin/api-admin-benchmarks-benchmark-id-runs-model-version-id-post';
import { apiAdminBenchmarksBenchmarkIdRunsPost } from '../fn/admin/api-admin-benchmarks-benchmark-id-runs-post';
import { ApiAdminBenchmarksBenchmarkIdRunsPost$Params } from '../fn/admin/api-admin-benchmarks-benchmark-id-runs-post';
import { apiAdminBenchmarksBenchmarkIdSttSamplesPost } from '../fn/admin/api-admin-benchmarks-benchmark-id-stt-samples-post';
import { ApiAdminBenchmarksBenchmarkIdSttSamplesPost$Params } from '../fn/admin/api-admin-benchmarks-benchmark-id-stt-samples-post';
import { apiAdminBenchmarksGet } from '../fn/admin/api-admin-benchmarks-get';
import { ApiAdminBenchmarksGet$Params } from '../fn/admin/api-admin-benchmarks-get';
import { apiAdminBenchmarksPost } from '../fn/admin/api-admin-benchmarks-post';
import { ApiAdminBenchmarksPost$Params } from '../fn/admin/api-admin-benchmarks-post';
import { apiAdminBillingPlansCodePut } from '../fn/admin/api-admin-billing-plans-code-put';
import { ApiAdminBillingPlansCodePut$Params } from '../fn/admin/api-admin-billing-plans-code-put';
import { apiAdminBillingPlansGet } from '../fn/admin/api-admin-billing-plans-get';
import { ApiAdminBillingPlansGet$Params } from '../fn/admin/api-admin-billing-plans-get';
import { apiAdminGenerateUserTokenPost } from '../fn/admin/api-admin-generate-user-token-post';
import { ApiAdminGenerateUserTokenPost$Params } from '../fn/admin/api-admin-generate-user-token-post';
import { apiAdminLanguageLocalesPost } from '../fn/admin/api-admin-language-locales-post';
import { ApiAdminLanguageLocalesPost$Params } from '../fn/admin/api-admin-language-locales-post';
import { apiAdminLivekitSipDispatchRulesDispatchRuleIdDelete } from '../fn/admin/api-admin-livekit-sip-dispatch-rules-dispatch-rule-id-delete';
import { ApiAdminLivekitSipDispatchRulesDispatchRuleIdDelete$Params } from '../fn/admin/api-admin-livekit-sip-dispatch-rules-dispatch-rule-id-delete';
import { apiAdminLivekitSipDispatchRulesGet } from '../fn/admin/api-admin-livekit-sip-dispatch-rules-get';
import { ApiAdminLivekitSipDispatchRulesGet$Params } from '../fn/admin/api-admin-livekit-sip-dispatch-rules-get';
import { apiAdminLivekitSipSystemTrunksPost } from '../fn/admin/api-admin-livekit-sip-system-trunks-post';
import { ApiAdminLivekitSipSystemTrunksPost$Params } from '../fn/admin/api-admin-livekit-sip-system-trunks-post';
import { apiAdminLivekitSipTrunksGet } from '../fn/admin/api-admin-livekit-sip-trunks-get';
import { ApiAdminLivekitSipTrunksGet$Params } from '../fn/admin/api-admin-livekit-sip-trunks-get';
import { apiAdminLivekitSipTrunksTrunkIdDelete } from '../fn/admin/api-admin-livekit-sip-trunks-trunk-id-delete';
import { ApiAdminLivekitSipTrunksTrunkIdDelete$Params } from '../fn/admin/api-admin-livekit-sip-trunks-trunk-id-delete';
import { apiAdminModelsHierarchyGet } from '../fn/admin/api-admin-models-hierarchy-get';
import { ApiAdminModelsHierarchyGet$Params } from '../fn/admin/api-admin-models-hierarchy-get';
import { apiAdminModelsLlmSyncPost } from '../fn/admin/api-admin-models-llm-sync-post';
import { ApiAdminModelsLlmSyncPost$Params } from '../fn/admin/api-admin-models-llm-sync-post';
import { apiAdminModelsModelIdPut } from '../fn/admin/api-admin-models-model-id-put';
import { ApiAdminModelsModelIdPut$Params } from '../fn/admin/api-admin-models-model-id-put';
import { apiAdminModelsRealtimeSyncPost } from '../fn/admin/api-admin-models-realtime-sync-post';
import { ApiAdminModelsRealtimeSyncPost$Params } from '../fn/admin/api-admin-models-realtime-sync-post';
import { apiAdminModelsSttSyncPost } from '../fn/admin/api-admin-models-stt-sync-post';
import { ApiAdminModelsSttSyncPost$Params } from '../fn/admin/api-admin-models-stt-sync-post';
import { apiAdminModelsTtsSyncPost } from '../fn/admin/api-admin-models-tts-sync-post';
import { ApiAdminModelsTtsSyncPost$Params } from '../fn/admin/api-admin-models-tts-sync-post';
import { apiAdminModelsVadSyncPost } from '../fn/admin/api-admin-models-vad-sync-post';
import { ApiAdminModelsVadSyncPost$Params } from '../fn/admin/api-admin-models-vad-sync-post';
import { apiAdminModelVersionsVersionIdBenchmarkRunItemsGet } from '../fn/admin/api-admin-model-versions-version-id-benchmark-run-items-get';
import { ApiAdminModelVersionsVersionIdBenchmarkRunItemsGet$Params } from '../fn/admin/api-admin-model-versions-version-id-benchmark-run-items-get';
import { apiAdminModelVersionsVersionIdPut } from '../fn/admin/api-admin-model-versions-version-id-put';
import { ApiAdminModelVersionsVersionIdPut$Params } from '../fn/admin/api-admin-model-versions-version-id-put';
import { apiAdminSettingsGet } from '../fn/admin/api-admin-settings-get';
import { ApiAdminSettingsGet$Params } from '../fn/admin/api-admin-settings-get';
import { apiAdminSettingsKeyGet } from '../fn/admin/api-admin-settings-key-get';
import { ApiAdminSettingsKeyGet$Params } from '../fn/admin/api-admin-settings-key-get';
import { apiAdminSettingsKeyPut } from '../fn/admin/api-admin-settings-key-put';
import { ApiAdminSettingsKeyPut$Params } from '../fn/admin/api-admin-settings-key-put';
import { apiAdminSyncCustomersPost } from '../fn/admin/api-admin-sync-customers-post';
import { ApiAdminSyncCustomersPost$Params } from '../fn/admin/api-admin-sync-customers-post';
import { apiAdminUsersGet } from '../fn/admin/api-admin-users-get';
import { ApiAdminUsersGet$Params } from '../fn/admin/api-admin-users-get';
import { BenchmarkDetailDto } from '../models/benchmark-detail-dto';
import { BenchmarkRunDetailDto } from '../models/benchmark-run-detail-dto';
import { BenchmarkRunItemSummaryDtoPaginatedResult } from '../models/benchmark-run-item-summary-dto-paginated-result';
import { BenchmarkRunSummaryDtoPaginatedResult } from '../models/benchmark-run-summary-dto-paginated-result';
import { BenchmarkSummaryDto } from '../models/benchmark-summary-dto';
import { CreateSttBenchmarkSampleResult } from '../models/create-stt-benchmark-sample-result';
import { EnqueueBenchmarkAllRunsResult } from '../models/enqueue-benchmark-all-runs-result';
import { EnqueueBenchmarkRunResult } from '../models/enqueue-benchmark-run-result';
import { GenerateUserTokenResult } from '../models/generate-user-token-result';
import { GetLiveKitSipTrunksResult } from '../models/get-live-kit-sip-trunks-result';
import { GetModelsHierarchyResult } from '../models/get-models-hierarchy-result';
import { GetPlansResult } from '../models/get-plans-result';
import { LanguageLocaleDto } from '../models/language-locale-dto';
import { LiveKitSipDispatchRule } from '../models/live-kit-sip-dispatch-rule';
import { ModelHierarchy } from '../models/model-hierarchy';
import { ModelVersionHierarchy } from '../models/model-version-hierarchy';
import { PlanDto } from '../models/plan-dto';
import { SettingDto } from '../models/setting-dto';
import { SettingValueResult } from '../models/setting-value-result';
import { StopBenchmarkRunItemResult } from '../models/stop-benchmark-run-item-result';
import { StopBenchmarkRunResult } from '../models/stop-benchmark-run-result';
import { SyncCustomersWithGetLagoResult } from '../models/sync-customers-with-get-lago-result';
import { SyncModelsResult } from '../models/sync-models-result';
import { UpsertSystemSipTrunksResult } from '../models/upsert-system-sip-trunks-result';
import { UserListItem } from '../models/user-list-item';


/**
 * Admin-only actions based on your system role
 */
@Injectable({ providedIn: 'root' })
export class AdminService extends BaseService {
  constructor(config: Configuration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiAdminGenerateUserTokenPost()` */
  static readonly ApiAdminGenerateUserTokenPostPath = '/api/Admin/generate-user-token';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiAdminGenerateUserTokenPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiAdminGenerateUserTokenPost$Response(params?: ApiAdminGenerateUserTokenPost$Params, context?: HttpContext): Observable<StrictHttpResponse<GenerateUserTokenResult>> {
    const obs = apiAdminGenerateUserTokenPost(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiAdminGenerateUserTokenPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiAdminGenerateUserTokenPost(params?: ApiAdminGenerateUserTokenPost$Params, context?: HttpContext): Observable<GenerateUserTokenResult> {
    const resp = this.apiAdminGenerateUserTokenPost$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<GenerateUserTokenResult>): GenerateUserTokenResult => r.body)
    );
  }

  /** Path part for operation `apiAdminUsersGet()` */
  static readonly ApiAdminUsersGetPath = '/api/Admin/users';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiAdminUsersGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAdminUsersGet$Response(params?: ApiAdminUsersGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<UserListItem>>> {
    const obs = apiAdminUsersGet(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiAdminUsersGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAdminUsersGet(params?: ApiAdminUsersGet$Params, context?: HttpContext): Observable<Array<UserListItem>> {
    const resp = this.apiAdminUsersGet$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<UserListItem>>): Array<UserListItem> => r.body)
    );
  }

  /** Path part for operation `apiAdminModelsModelIdPut()` */
  static readonly ApiAdminModelsModelIdPutPath = '/api/Admin/models/{modelId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiAdminModelsModelIdPut()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiAdminModelsModelIdPut$Response(params: ApiAdminModelsModelIdPut$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelHierarchy>> {
    const obs = apiAdminModelsModelIdPut(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiAdminModelsModelIdPut$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiAdminModelsModelIdPut(params: ApiAdminModelsModelIdPut$Params, context?: HttpContext): Observable<ModelHierarchy> {
    const resp = this.apiAdminModelsModelIdPut$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<ModelHierarchy>): ModelHierarchy => r.body)
    );
  }

  /** Path part for operation `apiAdminModelsHierarchyGet()` */
  static readonly ApiAdminModelsHierarchyGetPath = '/api/Admin/models/hierarchy';

  /**
   * Admin-каталог моделей: возвращает RAW prices (без plan-коэф) — чтобы
   * админка видела ровно те ставки, которые они выставили. По умолчанию
   * IncludeAll=true (всё, включая нерекомендованные) — админу нужно
   * видеть весь sync, а не curated подмножество.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiAdminModelsHierarchyGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAdminModelsHierarchyGet$Response(params?: ApiAdminModelsHierarchyGet$Params, context?: HttpContext): Observable<StrictHttpResponse<GetModelsHierarchyResult>> {
    const obs = apiAdminModelsHierarchyGet(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Admin-каталог моделей: возвращает RAW prices (без plan-коэф) — чтобы
   * админка видела ровно те ставки, которые они выставили. По умолчанию
   * IncludeAll=true (всё, включая нерекомендованные) — админу нужно
   * видеть весь sync, а не curated подмножество.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiAdminModelsHierarchyGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAdminModelsHierarchyGet(params?: ApiAdminModelsHierarchyGet$Params, context?: HttpContext): Observable<GetModelsHierarchyResult> {
    const resp = this.apiAdminModelsHierarchyGet$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<GetModelsHierarchyResult>): GetModelsHierarchyResult => r.body)
    );
  }

  /** Path part for operation `apiAdminModelVersionsVersionIdPut()` */
  static readonly ApiAdminModelVersionsVersionIdPutPath = '/api/Admin/model-versions/{versionId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiAdminModelVersionsVersionIdPut()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiAdminModelVersionsVersionIdPut$Response(params: ApiAdminModelVersionsVersionIdPut$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelVersionHierarchy>> {
    const obs = apiAdminModelVersionsVersionIdPut(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiAdminModelVersionsVersionIdPut$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiAdminModelVersionsVersionIdPut(params: ApiAdminModelVersionsVersionIdPut$Params, context?: HttpContext): Observable<ModelVersionHierarchy> {
    const resp = this.apiAdminModelVersionsVersionIdPut$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<ModelVersionHierarchy>): ModelVersionHierarchy => r.body)
    );
  }

  /** Path part for operation `apiAdminLanguageLocalesPost()` */
  static readonly ApiAdminLanguageLocalesPostPath = '/api/Admin/language-locales';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiAdminLanguageLocalesPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiAdminLanguageLocalesPost$Response(params?: ApiAdminLanguageLocalesPost$Params, context?: HttpContext): Observable<StrictHttpResponse<LanguageLocaleDto>> {
    const obs = apiAdminLanguageLocalesPost(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiAdminLanguageLocalesPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiAdminLanguageLocalesPost(params?: ApiAdminLanguageLocalesPost$Params, context?: HttpContext): Observable<LanguageLocaleDto> {
    const resp = this.apiAdminLanguageLocalesPost$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<LanguageLocaleDto>): LanguageLocaleDto => r.body)
    );
  }

  /** Path part for operation `apiAdminSyncCustomersPost()` */
  static readonly ApiAdminSyncCustomersPostPath = '/api/Admin/sync-customers';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiAdminSyncCustomersPost()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAdminSyncCustomersPost$Response(params?: ApiAdminSyncCustomersPost$Params, context?: HttpContext): Observable<StrictHttpResponse<SyncCustomersWithGetLagoResult>> {
    const obs = apiAdminSyncCustomersPost(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiAdminSyncCustomersPost$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAdminSyncCustomersPost(params?: ApiAdminSyncCustomersPost$Params, context?: HttpContext): Observable<SyncCustomersWithGetLagoResult> {
    const resp = this.apiAdminSyncCustomersPost$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<SyncCustomersWithGetLagoResult>): SyncCustomersWithGetLagoResult => r.body)
    );
  }

  /** Path part for operation `apiAdminBillingPlansGet()` */
  static readonly ApiAdminBillingPlansGetPath = '/api/Admin/billing/plans';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiAdminBillingPlansGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAdminBillingPlansGet$Response(params?: ApiAdminBillingPlansGet$Params, context?: HttpContext): Observable<StrictHttpResponse<GetPlansResult>> {
    const obs = apiAdminBillingPlansGet(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiAdminBillingPlansGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAdminBillingPlansGet(params?: ApiAdminBillingPlansGet$Params, context?: HttpContext): Observable<GetPlansResult> {
    const resp = this.apiAdminBillingPlansGet$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<GetPlansResult>): GetPlansResult => r.body)
    );
  }

  /** Path part for operation `apiAdminBillingPlansCodePut()` */
  static readonly ApiAdminBillingPlansCodePutPath = '/api/Admin/billing/plans/{code}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiAdminBillingPlansCodePut()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiAdminBillingPlansCodePut$Response(params: ApiAdminBillingPlansCodePut$Params, context?: HttpContext): Observable<StrictHttpResponse<PlanDto>> {
    const obs = apiAdminBillingPlansCodePut(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiAdminBillingPlansCodePut$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiAdminBillingPlansCodePut(params: ApiAdminBillingPlansCodePut$Params, context?: HttpContext): Observable<PlanDto> {
    const resp = this.apiAdminBillingPlansCodePut$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<PlanDto>): PlanDto => r.body)
    );
  }

  /** Path part for operation `apiAdminModelsSttSyncPost()` */
  static readonly ApiAdminModelsSttSyncPostPath = '/api/Admin/models/stt/sync';

  /**
   * Унифицированный sync STT моделей по gateway-коду (aws / deepgram / azure / openai / ...).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiAdminModelsSttSyncPost()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAdminModelsSttSyncPost$Response(params?: ApiAdminModelsSttSyncPost$Params, context?: HttpContext): Observable<StrictHttpResponse<SyncModelsResult>> {
    const obs = apiAdminModelsSttSyncPost(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Унифицированный sync STT моделей по gateway-коду (aws / deepgram / azure / openai / ...).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiAdminModelsSttSyncPost$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAdminModelsSttSyncPost(params?: ApiAdminModelsSttSyncPost$Params, context?: HttpContext): Observable<SyncModelsResult> {
    const resp = this.apiAdminModelsSttSyncPost$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<SyncModelsResult>): SyncModelsResult => r.body)
    );
  }

  /** Path part for operation `apiAdminModelsTtsSyncPost()` */
  static readonly ApiAdminModelsTtsSyncPostPath = '/api/Admin/models/tts/sync';

  /**
   * Унифицированный sync TTS моделей по gateway-коду. Голоса синкаются вместе с моделями
   * (как ModelVersion). Покрывает azure / minimax / elevenlabs / openai.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiAdminModelsTtsSyncPost()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAdminModelsTtsSyncPost$Response(params?: ApiAdminModelsTtsSyncPost$Params, context?: HttpContext): Observable<StrictHttpResponse<SyncModelsResult>> {
    const obs = apiAdminModelsTtsSyncPost(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Унифицированный sync TTS моделей по gateway-коду. Голоса синкаются вместе с моделями
   * (как ModelVersion). Покрывает azure / minimax / elevenlabs / openai.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiAdminModelsTtsSyncPost$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAdminModelsTtsSyncPost(params?: ApiAdminModelsTtsSyncPost$Params, context?: HttpContext): Observable<SyncModelsResult> {
    const resp = this.apiAdminModelsTtsSyncPost$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<SyncModelsResult>): SyncModelsResult => r.body)
    );
  }

  /** Path part for operation `apiAdminModelsLlmSyncPost()` */
  static readonly ApiAdminModelsLlmSyncPostPath = '/api/Admin/models/llm/sync';

  /**
   * Унифицированный sync LLM моделей. Сейчас только openrouter.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiAdminModelsLlmSyncPost()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAdminModelsLlmSyncPost$Response(params?: ApiAdminModelsLlmSyncPost$Params, context?: HttpContext): Observable<StrictHttpResponse<SyncModelsResult>> {
    const obs = apiAdminModelsLlmSyncPost(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Унифицированный sync LLM моделей. Сейчас только openrouter.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiAdminModelsLlmSyncPost$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAdminModelsLlmSyncPost(params?: ApiAdminModelsLlmSyncPost$Params, context?: HttpContext): Observable<SyncModelsResult> {
    const resp = this.apiAdminModelsLlmSyncPost$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<SyncModelsResult>): SyncModelsResult => r.body)
    );
  }

  /** Path part for operation `apiAdminModelsVadSyncPost()` */
  static readonly ApiAdminModelsVadSyncPostPath = '/api/Admin/models/vad/sync';

  /**
   * Sync VAD моделей по gateway-коду (сейчас — `embedded` для Silero).
   * Модель+версия перезаписывают schema параметров в
   * AspNetBackend.Domain.Entities.ModelVersion.AdditionalProperties.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiAdminModelsVadSyncPost()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAdminModelsVadSyncPost$Response(params?: ApiAdminModelsVadSyncPost$Params, context?: HttpContext): Observable<StrictHttpResponse<SyncModelsResult>> {
    const obs = apiAdminModelsVadSyncPost(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Sync VAD моделей по gateway-коду (сейчас — `embedded` для Silero).
   * Модель+версия перезаписывают schema параметров в
   * AspNetBackend.Domain.Entities.ModelVersion.AdditionalProperties.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiAdminModelsVadSyncPost$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAdminModelsVadSyncPost(params?: ApiAdminModelsVadSyncPost$Params, context?: HttpContext): Observable<SyncModelsResult> {
    const resp = this.apiAdminModelsVadSyncPost$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<SyncModelsResult>): SyncModelsResult => r.body)
    );
  }

  /** Path part for operation `apiAdminModelsRealtimeSyncPost()` */
  static readonly ApiAdminModelsRealtimeSyncPostPath = '/api/Admin/models/realtime/sync';

  /**
   * Sync Realtime (voice-to-voice) моделей по gateway-коду
   * (openai / google-ai-studio). Заменяют всю цепочку STT+LLM+TTS+VAD
   * у агентов с AgentMode = Realtime.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiAdminModelsRealtimeSyncPost()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAdminModelsRealtimeSyncPost$Response(params?: ApiAdminModelsRealtimeSyncPost$Params, context?: HttpContext): Observable<StrictHttpResponse<SyncModelsResult>> {
    const obs = apiAdminModelsRealtimeSyncPost(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Sync Realtime (voice-to-voice) моделей по gateway-коду
   * (openai / google-ai-studio). Заменяют всю цепочку STT+LLM+TTS+VAD
   * у агентов с AgentMode = Realtime.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiAdminModelsRealtimeSyncPost$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAdminModelsRealtimeSyncPost(params?: ApiAdminModelsRealtimeSyncPost$Params, context?: HttpContext): Observable<SyncModelsResult> {
    const resp = this.apiAdminModelsRealtimeSyncPost$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<SyncModelsResult>): SyncModelsResult => r.body)
    );
  }

  /** Path part for operation `apiAdminSettingsGet()` */
  static readonly ApiAdminSettingsGetPath = '/api/Admin/settings';

  /**
   * Runtime settings (плоский key/value, see AspNetBackend.Domain.Enums.SettingKey) —
   * возвращает все ключи enum'а с текущими значениями. Незаполненные
   * идут с `value=null`, `updatedAt=null`.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiAdminSettingsGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAdminSettingsGet$Response(params?: ApiAdminSettingsGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<SettingDto>>> {
    const obs = apiAdminSettingsGet(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Runtime settings (плоский key/value, see AspNetBackend.Domain.Enums.SettingKey) —
   * возвращает все ключи enum'а с текущими значениями. Незаполненные
   * идут с `value=null`, `updatedAt=null`.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiAdminSettingsGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAdminSettingsGet(params?: ApiAdminSettingsGet$Params, context?: HttpContext): Observable<Array<SettingDto>> {
    const resp = this.apiAdminSettingsGet$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<SettingDto>>): Array<SettingDto> => r.body)
    );
  }

  /** Path part for operation `apiAdminSettingsKeyGet()` */
  static readonly ApiAdminSettingsKeyGetPath = '/api/Admin/settings/{key}';

  /**
   * Возвращает значение конкретного setting'а или null.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiAdminSettingsKeyGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAdminSettingsKeyGet$Response(params: ApiAdminSettingsKeyGet$Params, context?: HttpContext): Observable<StrictHttpResponse<SettingValueResult>> {
    const obs = apiAdminSettingsKeyGet(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Возвращает значение конкретного setting'а или null.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiAdminSettingsKeyGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAdminSettingsKeyGet(params: ApiAdminSettingsKeyGet$Params, context?: HttpContext): Observable<SettingValueResult> {
    const resp = this.apiAdminSettingsKeyGet$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<SettingValueResult>): SettingValueResult => r.body)
    );
  }

  /** Path part for operation `apiAdminSettingsKeyPut()` */
  static readonly ApiAdminSettingsKeyPutPath = '/api/Admin/settings/{key}';

  /**
   * Upsert значения setting'а.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiAdminSettingsKeyPut()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiAdminSettingsKeyPut$Response(params: ApiAdminSettingsKeyPut$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = apiAdminSettingsKeyPut(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Upsert значения setting'а.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiAdminSettingsKeyPut$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiAdminSettingsKeyPut(params: ApiAdminSettingsKeyPut$Params, context?: HttpContext): Observable<void> {
    const resp = this.apiAdminSettingsKeyPut$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiAdminLivekitSipTrunksGet()` */
  static readonly ApiAdminLivekitSipTrunksGetPath = '/api/Admin/livekit/sip/trunks';

  /**
   * Все SIP-trunks LiveKit-кластера (inbound + outbound). Прямой проброс
   * без фильтрации по БД — видно и orphan'ы. Для диагностики Conflicting-
   * ошибок и ручной чистки.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiAdminLivekitSipTrunksGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAdminLivekitSipTrunksGet$Response(params?: ApiAdminLivekitSipTrunksGet$Params, context?: HttpContext): Observable<StrictHttpResponse<GetLiveKitSipTrunksResult>> {
    const obs = apiAdminLivekitSipTrunksGet(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Все SIP-trunks LiveKit-кластера (inbound + outbound). Прямой проброс
   * без фильтрации по БД — видно и orphan'ы. Для диагностики Conflicting-
   * ошибок и ручной чистки.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiAdminLivekitSipTrunksGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAdminLivekitSipTrunksGet(params?: ApiAdminLivekitSipTrunksGet$Params, context?: HttpContext): Observable<GetLiveKitSipTrunksResult> {
    const resp = this.apiAdminLivekitSipTrunksGet$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<GetLiveKitSipTrunksResult>): GetLiveKitSipTrunksResult => r.body)
    );
  }

  /** Path part for operation `apiAdminLivekitSipDispatchRulesGet()` */
  static readonly ApiAdminLivekitSipDispatchRulesGetPath = '/api/Admin/livekit/sip/dispatch-rules';

  /**
   * Все SIP DispatchRule в LiveKit (raw, без фильтрации по БД).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiAdminLivekitSipDispatchRulesGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAdminLivekitSipDispatchRulesGet$Response(params?: ApiAdminLivekitSipDispatchRulesGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<LiveKitSipDispatchRule>>> {
    const obs = apiAdminLivekitSipDispatchRulesGet(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Все SIP DispatchRule в LiveKit (raw, без фильтрации по БД).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiAdminLivekitSipDispatchRulesGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAdminLivekitSipDispatchRulesGet(params?: ApiAdminLivekitSipDispatchRulesGet$Params, context?: HttpContext): Observable<Array<LiveKitSipDispatchRule>> {
    const resp = this.apiAdminLivekitSipDispatchRulesGet$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<LiveKitSipDispatchRule>>): Array<LiveKitSipDispatchRule> => r.body)
    );
  }

  /** Path part for operation `apiAdminLivekitSipTrunksTrunkIdDelete()` */
  static readonly ApiAdminLivekitSipTrunksTrunkIdDeletePath = '/api/Admin/livekit/sip/trunks/{trunkId}';

  /**
   * Удалить SIP-trunk по LiveKit-id (inbound или outbound — SDK не различает).
   * Не чистит ссылки в CustomSipAccount — следующий Bind/Reprovision создаст
   * новый.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiAdminLivekitSipTrunksTrunkIdDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAdminLivekitSipTrunksTrunkIdDelete$Response(params: ApiAdminLivekitSipTrunksTrunkIdDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = apiAdminLivekitSipTrunksTrunkIdDelete(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Удалить SIP-trunk по LiveKit-id (inbound или outbound — SDK не различает).
   * Не чистит ссылки в CustomSipAccount — следующий Bind/Reprovision создаст
   * новый.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiAdminLivekitSipTrunksTrunkIdDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAdminLivekitSipTrunksTrunkIdDelete(params: ApiAdminLivekitSipTrunksTrunkIdDelete$Params, context?: HttpContext): Observable<void> {
    const resp = this.apiAdminLivekitSipTrunksTrunkIdDelete$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiAdminLivekitSipDispatchRulesDispatchRuleIdDelete()` */
  static readonly ApiAdminLivekitSipDispatchRulesDispatchRuleIdDeletePath = '/api/Admin/livekit/sip/dispatch-rules/{dispatchRuleId}';

  /**
   * Удалить SIP DispatchRule по LiveKit-id. Не чистит ссылки в
   * CustomSipAccount.LiveKitDispatchRuleId.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiAdminLivekitSipDispatchRulesDispatchRuleIdDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAdminLivekitSipDispatchRulesDispatchRuleIdDelete$Response(params: ApiAdminLivekitSipDispatchRulesDispatchRuleIdDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = apiAdminLivekitSipDispatchRulesDispatchRuleIdDelete(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Удалить SIP DispatchRule по LiveKit-id. Не чистит ссылки в
   * CustomSipAccount.LiveKitDispatchRuleId.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiAdminLivekitSipDispatchRulesDispatchRuleIdDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAdminLivekitSipDispatchRulesDispatchRuleIdDelete(params: ApiAdminLivekitSipDispatchRulesDispatchRuleIdDelete$Params, context?: HttpContext): Observable<void> {
    const resp = this.apiAdminLivekitSipDispatchRulesDispatchRuleIdDelete$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiAdminLivekitSipSystemTrunksPost()` */
  static readonly ApiAdminLivekitSipSystemTrunksPostPath = '/api/Admin/livekit/sip/system-trunks';

  /**
   * Bring the system SIP infrastructure in LiveKit to its expected shape:
   * the <b>Bridge Trunk</b> (inbound), the <b>Individual</b> rule with the
   * `phone-` prefix, and the <b>Callee</b> rule used to invite live
   * operators. All Twilio and Voximplant calls travel through them.
   *             
   *
   * Idempotent: existing objects are reused, only what is missing gets
   * created. This used to be provisioned when a phone number was added —
   * now it is an explicit admin operation, since an installation-wide
   * singleton is not a property of a particular number.
   * `recreate=true` deletes and recreates, for when the configuration
   * drifted (LiveKit does not allow changing it with an update). WARNING:
   * this interrupts inbound calls for a few seconds. Ongoing conversations
   * are not affected.
   * Does NOT cover trunks of Custom accounts — those are tied to one
   * account's numbers and have their own reprovision by TelecomAccountId.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiAdminLivekitSipSystemTrunksPost()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAdminLivekitSipSystemTrunksPost$Response(params?: ApiAdminLivekitSipSystemTrunksPost$Params, context?: HttpContext): Observable<StrictHttpResponse<UpsertSystemSipTrunksResult>> {
    const obs = apiAdminLivekitSipSystemTrunksPost(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Bring the system SIP infrastructure in LiveKit to its expected shape:
   * the <b>Bridge Trunk</b> (inbound), the <b>Individual</b> rule with the
   * `phone-` prefix, and the <b>Callee</b> rule used to invite live
   * operators. All Twilio and Voximplant calls travel through them.
   *             
   *
   * Idempotent: existing objects are reused, only what is missing gets
   * created. This used to be provisioned when a phone number was added —
   * now it is an explicit admin operation, since an installation-wide
   * singleton is not a property of a particular number.
   * `recreate=true` deletes and recreates, for when the configuration
   * drifted (LiveKit does not allow changing it with an update). WARNING:
   * this interrupts inbound calls for a few seconds. Ongoing conversations
   * are not affected.
   * Does NOT cover trunks of Custom accounts — those are tied to one
   * account's numbers and have their own reprovision by TelecomAccountId.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiAdminLivekitSipSystemTrunksPost$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAdminLivekitSipSystemTrunksPost(params?: ApiAdminLivekitSipSystemTrunksPost$Params, context?: HttpContext): Observable<UpsertSystemSipTrunksResult> {
    const resp = this.apiAdminLivekitSipSystemTrunksPost$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<UpsertSystemSipTrunksResult>): UpsertSystemSipTrunksResult => r.body)
    );
  }

  /** Path part for operation `apiAdminBenchmarksGet()` */
  static readonly ApiAdminBenchmarksGetPath = '/api/Admin/benchmarks';

  /**
   * Лист всех бенчмарков (опциональный фильтр по ModelType llm/stt).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiAdminBenchmarksGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAdminBenchmarksGet$Response(params?: ApiAdminBenchmarksGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<BenchmarkSummaryDto>>> {
    const obs = apiAdminBenchmarksGet(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Лист всех бенчмарков (опциональный фильтр по ModelType llm/stt).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiAdminBenchmarksGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAdminBenchmarksGet(params?: ApiAdminBenchmarksGet$Params, context?: HttpContext): Observable<Array<BenchmarkSummaryDto>> {
    const resp = this.apiAdminBenchmarksGet$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<BenchmarkSummaryDto>>): Array<BenchmarkSummaryDto> => r.body)
    );
  }

  /** Path part for operation `apiAdminBenchmarksPost()` */
  static readonly ApiAdminBenchmarksPostPath = '/api/Admin/benchmarks';

  /**
   * Создать бенч. Опциональный `modelVersionIds` сразу привяжет перечисленные версии (пустой/null = никого).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiAdminBenchmarksPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiAdminBenchmarksPost$Response(params?: ApiAdminBenchmarksPost$Params, context?: HttpContext): Observable<StrictHttpResponse<BenchmarkDetailDto>> {
    const obs = apiAdminBenchmarksPost(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Создать бенч. Опциональный `modelVersionIds` сразу привяжет перечисленные версии (пустой/null = никого).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiAdminBenchmarksPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiAdminBenchmarksPost(params?: ApiAdminBenchmarksPost$Params, context?: HttpContext): Observable<BenchmarkDetailDto> {
    const resp = this.apiAdminBenchmarksPost$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<BenchmarkDetailDto>): BenchmarkDetailDto => r.body)
    );
  }

  /** Path part for operation `apiAdminBenchmarksBenchmarkIdGet()` */
  static readonly ApiAdminBenchmarksBenchmarkIdGetPath = '/api/Admin/benchmarks/{benchmarkId}';

  /**
   * Один бенч с полной детализацией: привязанные ModelVersion + для STT-бенчей весь набор сэмплов.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiAdminBenchmarksBenchmarkIdGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAdminBenchmarksBenchmarkIdGet$Response(params: ApiAdminBenchmarksBenchmarkIdGet$Params, context?: HttpContext): Observable<StrictHttpResponse<BenchmarkDetailDto>> {
    const obs = apiAdminBenchmarksBenchmarkIdGet(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Один бенч с полной детализацией: привязанные ModelVersion + для STT-бенчей весь набор сэмплов.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiAdminBenchmarksBenchmarkIdGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAdminBenchmarksBenchmarkIdGet(params: ApiAdminBenchmarksBenchmarkIdGet$Params, context?: HttpContext): Observable<BenchmarkDetailDto> {
    const resp = this.apiAdminBenchmarksBenchmarkIdGet$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<BenchmarkDetailDto>): BenchmarkDetailDto => r.body)
    );
  }

  /** Path part for operation `apiAdminBenchmarksBenchmarkIdPut()` */
  static readonly ApiAdminBenchmarksBenchmarkIdPutPath = '/api/Admin/benchmarks/{benchmarkId}';

  /**
   * Обновить бенч. `modelVersionIds`: `null` — не трогаем привязки;
   * `[]` — очищаем; непустой — full-replace текущего списка.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiAdminBenchmarksBenchmarkIdPut()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiAdminBenchmarksBenchmarkIdPut$Response(params: ApiAdminBenchmarksBenchmarkIdPut$Params, context?: HttpContext): Observable<StrictHttpResponse<BenchmarkDetailDto>> {
    const obs = apiAdminBenchmarksBenchmarkIdPut(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Обновить бенч. `modelVersionIds`: `null` — не трогаем привязки;
   * `[]` — очищаем; непустой — full-replace текущего списка.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiAdminBenchmarksBenchmarkIdPut$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiAdminBenchmarksBenchmarkIdPut(params: ApiAdminBenchmarksBenchmarkIdPut$Params, context?: HttpContext): Observable<BenchmarkDetailDto> {
    const resp = this.apiAdminBenchmarksBenchmarkIdPut$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<BenchmarkDetailDto>): BenchmarkDetailDto => r.body)
    );
  }

  /** Path part for operation `apiAdminBenchmarksBenchmarkIdDelete()` */
  static readonly ApiAdminBenchmarksBenchmarkIdDeletePath = '/api/Admin/benchmarks/{benchmarkId}';

  /**
   * Soft-delete бенча. Перед пометкой row как удалённого: снимаем все
   * активные (Initial/Running) прогоны — Hangfire-jobs убиваем, статус
   * переводим в Stopped, broadcast'им.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiAdminBenchmarksBenchmarkIdDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAdminBenchmarksBenchmarkIdDelete$Response(params: ApiAdminBenchmarksBenchmarkIdDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = apiAdminBenchmarksBenchmarkIdDelete(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Soft-delete бенча. Перед пометкой row как удалённого: снимаем все
   * активные (Initial/Running) прогоны — Hangfire-jobs убиваем, статус
   * переводим в Stopped, broadcast'им.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiAdminBenchmarksBenchmarkIdDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAdminBenchmarksBenchmarkIdDelete(params: ApiAdminBenchmarksBenchmarkIdDelete$Params, context?: HttpContext): Observable<void> {
    const resp = this.apiAdminBenchmarksBenchmarkIdDelete$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiAdminBenchmarksBenchmarkIdRunsGet()` */
  static readonly ApiAdminBenchmarksBenchmarkIdRunsGetPath = '/api/Admin/benchmarks/{benchmarkId}/runs';

  /**
   * Прогоны конкретного бенча (курсорная пагинация, CreatedAt DESC).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiAdminBenchmarksBenchmarkIdRunsGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAdminBenchmarksBenchmarkIdRunsGet$Response(params: ApiAdminBenchmarksBenchmarkIdRunsGet$Params, context?: HttpContext): Observable<StrictHttpResponse<BenchmarkRunSummaryDtoPaginatedResult>> {
    const obs = apiAdminBenchmarksBenchmarkIdRunsGet(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Прогоны конкретного бенча (курсорная пагинация, CreatedAt DESC).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiAdminBenchmarksBenchmarkIdRunsGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAdminBenchmarksBenchmarkIdRunsGet(params: ApiAdminBenchmarksBenchmarkIdRunsGet$Params, context?: HttpContext): Observable<BenchmarkRunSummaryDtoPaginatedResult> {
    const resp = this.apiAdminBenchmarksBenchmarkIdRunsGet$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<BenchmarkRunSummaryDtoPaginatedResult>): BenchmarkRunSummaryDtoPaginatedResult => r.body)
    );
  }

  /** Path part for operation `apiAdminBenchmarksBenchmarkIdRunsPost()` */
  static readonly ApiAdminBenchmarksBenchmarkIdRunsPostPath = '/api/Admin/benchmarks/{benchmarkId}/runs';

  /**
   * Постановка бенча в очередь по всем подключённым к нему версиям —
   * одна кнопка «прогнать всё» в админке. Возвращает список созданных
   * RunId (Status=Initial); прогресс каждого — через SignalR.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiAdminBenchmarksBenchmarkIdRunsPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiAdminBenchmarksBenchmarkIdRunsPost$Response(params: ApiAdminBenchmarksBenchmarkIdRunsPost$Params, context?: HttpContext): Observable<StrictHttpResponse<EnqueueBenchmarkAllRunsResult>> {
    const obs = apiAdminBenchmarksBenchmarkIdRunsPost(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Постановка бенча в очередь по всем подключённым к нему версиям —
   * одна кнопка «прогнать всё» в админке. Возвращает список созданных
   * RunId (Status=Initial); прогресс каждого — через SignalR.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiAdminBenchmarksBenchmarkIdRunsPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiAdminBenchmarksBenchmarkIdRunsPost(params: ApiAdminBenchmarksBenchmarkIdRunsPost$Params, context?: HttpContext): Observable<EnqueueBenchmarkAllRunsResult> {
    const resp = this.apiAdminBenchmarksBenchmarkIdRunsPost$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<EnqueueBenchmarkAllRunsResult>): EnqueueBenchmarkAllRunsResult => r.body)
    );
  }

  /** Path part for operation `apiAdminBenchmarksBenchmarkIdRunsModelVersionIdPost()` */
  static readonly ApiAdminBenchmarksBenchmarkIdRunsModelVersionIdPostPath = '/api/Admin/benchmarks/{benchmarkId}/runs/{modelVersionId}';

  /**
   * Ad-hoc прогон бенча на ОДНОЙ конкретной ModelVersion — узко-таргетный
   * сценарий («перегнать эту версию»). Создаётся один parent run + один
   * item; воркер работает параллельно, статус — через SignalR.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiAdminBenchmarksBenchmarkIdRunsModelVersionIdPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiAdminBenchmarksBenchmarkIdRunsModelVersionIdPost$Response(params: ApiAdminBenchmarksBenchmarkIdRunsModelVersionIdPost$Params, context?: HttpContext): Observable<StrictHttpResponse<EnqueueBenchmarkRunResult>> {
    const obs = apiAdminBenchmarksBenchmarkIdRunsModelVersionIdPost(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Ad-hoc прогон бенча на ОДНОЙ конкретной ModelVersion — узко-таргетный
   * сценарий («перегнать эту версию»). Создаётся один parent run + один
   * item; воркер работает параллельно, статус — через SignalR.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiAdminBenchmarksBenchmarkIdRunsModelVersionIdPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiAdminBenchmarksBenchmarkIdRunsModelVersionIdPost(params: ApiAdminBenchmarksBenchmarkIdRunsModelVersionIdPost$Params, context?: HttpContext): Observable<EnqueueBenchmarkRunResult> {
    const resp = this.apiAdminBenchmarksBenchmarkIdRunsModelVersionIdPost$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<EnqueueBenchmarkRunResult>): EnqueueBenchmarkRunResult => r.body)
    );
  }

  /** Path part for operation `apiAdminBenchmarkRunsRunIdStopPost()` */
  static readonly ApiAdminBenchmarkRunsRunIdStopPostPath = '/api/Admin/benchmark-runs/{runId}/stop';

  /**
   * Стоп всего прогона: обходит все активные items, убивает их
   * Hangfire-jobs, финализирует Stopped, broadcast. Идемпотентно.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiAdminBenchmarkRunsRunIdStopPost()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAdminBenchmarkRunsRunIdStopPost$Response(params: ApiAdminBenchmarkRunsRunIdStopPost$Params, context?: HttpContext): Observable<StrictHttpResponse<StopBenchmarkRunResult>> {
    const obs = apiAdminBenchmarkRunsRunIdStopPost(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Стоп всего прогона: обходит все активные items, убивает их
   * Hangfire-jobs, финализирует Stopped, broadcast. Идемпотентно.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiAdminBenchmarkRunsRunIdStopPost$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAdminBenchmarkRunsRunIdStopPost(params: ApiAdminBenchmarkRunsRunIdStopPost$Params, context?: HttpContext): Observable<StopBenchmarkRunResult> {
    const resp = this.apiAdminBenchmarkRunsRunIdStopPost$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<StopBenchmarkRunResult>): StopBenchmarkRunResult => r.body)
    );
  }

  /** Path part for operation `apiAdminBenchmarkRunItemsItemIdStopPost()` */
  static readonly ApiAdminBenchmarkRunItemsItemIdStopPostPath = '/api/Admin/benchmark-run-items/{itemId}/stop';

  /**
   * Стоп одного item'а внутри прогона — «повисшая» ModelVersion
   * прибивается точечно, остальные продолжают. Если это был последний
   * живой item, parent run сам финализируется.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiAdminBenchmarkRunItemsItemIdStopPost()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAdminBenchmarkRunItemsItemIdStopPost$Response(params: ApiAdminBenchmarkRunItemsItemIdStopPost$Params, context?: HttpContext): Observable<StrictHttpResponse<StopBenchmarkRunItemResult>> {
    const obs = apiAdminBenchmarkRunItemsItemIdStopPost(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Стоп одного item'а внутри прогона — «повисшая» ModelVersion
   * прибивается точечно, остальные продолжают. Если это был последний
   * живой item, parent run сам финализируется.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiAdminBenchmarkRunItemsItemIdStopPost$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAdminBenchmarkRunItemsItemIdStopPost(params: ApiAdminBenchmarkRunItemsItemIdStopPost$Params, context?: HttpContext): Observable<StopBenchmarkRunItemResult> {
    const resp = this.apiAdminBenchmarkRunItemsItemIdStopPost$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<StopBenchmarkRunItemResult>): StopBenchmarkRunItemResult => r.body)
    );
  }

  /** Path part for operation `apiAdminBenchmarkRunsRunIdGet()` */
  static readonly ApiAdminBenchmarkRunsRunIdGetPath = '/api/Admin/benchmark-runs/{runId}';

  /**
   * Детали одного прогона с per-iteration результатами (для карточки
   * в админке — «что распозналось / где упало»).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiAdminBenchmarkRunsRunIdGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAdminBenchmarkRunsRunIdGet$Response(params: ApiAdminBenchmarkRunsRunIdGet$Params, context?: HttpContext): Observable<StrictHttpResponse<BenchmarkRunDetailDto>> {
    const obs = apiAdminBenchmarkRunsRunIdGet(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Детали одного прогона с per-iteration результатами (для карточки
   * в админке — «что распозналось / где упало»).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiAdminBenchmarkRunsRunIdGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAdminBenchmarkRunsRunIdGet(params: ApiAdminBenchmarkRunsRunIdGet$Params, context?: HttpContext): Observable<BenchmarkRunDetailDto> {
    const resp = this.apiAdminBenchmarkRunsRunIdGet$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<BenchmarkRunDetailDto>): BenchmarkRunDetailDto => r.body)
    );
  }

  /** Path part for operation `apiAdminModelVersionsVersionIdBenchmarkRunItemsGet()` */
  static readonly ApiAdminModelVersionsVersionIdBenchmarkRunItemsGetPath = '/api/Admin/model-versions/{versionId}/benchmark-run-items';

  /**
   * Прогоны (items) конкретной ModelVersion — эта версия внутри разных
   * parent-run'ов. Курсорная пагинация по CreatedAt DESC. Для карточки
   * версии и сравнения между запусками.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiAdminModelVersionsVersionIdBenchmarkRunItemsGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAdminModelVersionsVersionIdBenchmarkRunItemsGet$Response(params: ApiAdminModelVersionsVersionIdBenchmarkRunItemsGet$Params, context?: HttpContext): Observable<StrictHttpResponse<BenchmarkRunItemSummaryDtoPaginatedResult>> {
    const obs = apiAdminModelVersionsVersionIdBenchmarkRunItemsGet(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Прогоны (items) конкретной ModelVersion — эта версия внутри разных
   * parent-run'ов. Курсорная пагинация по CreatedAt DESC. Для карточки
   * версии и сравнения между запусками.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiAdminModelVersionsVersionIdBenchmarkRunItemsGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAdminModelVersionsVersionIdBenchmarkRunItemsGet(params: ApiAdminModelVersionsVersionIdBenchmarkRunItemsGet$Params, context?: HttpContext): Observable<BenchmarkRunItemSummaryDtoPaginatedResult> {
    const resp = this.apiAdminModelVersionsVersionIdBenchmarkRunItemsGet$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<BenchmarkRunItemSummaryDtoPaginatedResult>): BenchmarkRunItemSummaryDtoPaginatedResult => r.body)
    );
  }

  /** Path part for operation `apiAdminBenchmarksBenchmarkIdSttSamplesPost()` */
  static readonly ApiAdminBenchmarksBenchmarkIdSttSamplesPostPath = '/api/Admin/benchmarks/{benchmarkId}/stt-samples';

  /**
   * Добавить эталонный STT-образец. `FileId` — заранее загруженный
   * через `POST /api/files/generate-upload-url` файл. Handler
   * сконвертирует в WAV PCM 16k mono, сохранит его в bench-namespace,
   * оригинал в user-namespace останется как есть.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiAdminBenchmarksBenchmarkIdSttSamplesPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiAdminBenchmarksBenchmarkIdSttSamplesPost$Response(params: ApiAdminBenchmarksBenchmarkIdSttSamplesPost$Params, context?: HttpContext): Observable<StrictHttpResponse<CreateSttBenchmarkSampleResult>> {
    const obs = apiAdminBenchmarksBenchmarkIdSttSamplesPost(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Добавить эталонный STT-образец. `FileId` — заранее загруженный
   * через `POST /api/files/generate-upload-url` файл. Handler
   * сконвертирует в WAV PCM 16k mono, сохранит его в bench-namespace,
   * оригинал в user-namespace останется как есть.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiAdminBenchmarksBenchmarkIdSttSamplesPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiAdminBenchmarksBenchmarkIdSttSamplesPost(params: ApiAdminBenchmarksBenchmarkIdSttSamplesPost$Params, context?: HttpContext): Observable<CreateSttBenchmarkSampleResult> {
    const resp = this.apiAdminBenchmarksBenchmarkIdSttSamplesPost$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<CreateSttBenchmarkSampleResult>): CreateSttBenchmarkSampleResult => r.body)
    );
  }

}
